/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Response } from '../../models/response';
import { UpdateCartLineQuantityModel } from '../../models/update-cart-line-quantity-model';

export interface ApiCartCartUpdatequantityPut$Plain$Params {
      body?: UpdateCartLineQuantityModel
}

export function apiCartCartUpdatequantityPut$Plain(http: HttpClient, rootUrl: string, params?: ApiCartCartUpdatequantityPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
  const rb = new RequestBuilder(rootUrl, apiCartCartUpdatequantityPut$Plain.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Response>;
    })
  );
}

apiCartCartUpdatequantityPut$Plain.PATH = '/api/cart/cart/updatequantity';
